import comp from "./ActionForSelectModal";
export default comp;
